import React, { useState } from "react";
import SettingsAppearanceTab from "../../components-v2/profile-menu/settings/SettingsAppearanceTab";
import SettingsNotificationsTab from "../../components-v2/profile-menu/settings/SettingsNotificationsTab";
import SettingsLanguageTab from "../../components-v2/profile-menu/settings/SettingsLanguageTab";
import SettingsAccountTab from "../../components-v2/profile-menu/settings/SettingsAccountTab";
import SettingsIntegrationsTab from "../../components-v2/profile-menu/settings/SettingsIntegrationsTab";
import {
  PaletteIcon,
  BellIcon,
  LanguageIcon,
  UserCogIcon,
  PlugIcon,
  SaveIcon,
} from "../../components-v2/profile-menu/settings/SettingsIcons";
import "../../styles-v2/profile-menu/v2-settings-page.css";

const TABS = [
  { id: "appearance", label: "Appearance", icon: PaletteIcon },
  { id: "notifications", label: "Notifications", icon: BellIcon },
  { id: "language", label: "Language", icon: LanguageIcon },
  { id: "account", label: "Account", icon: UserCogIcon },
  { id: "integrations", label: "Integrations", icon: PlugIcon },
];

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("appearance");

  /* Appearance state */
  const [theme, setTheme] = useState("system");
  const [sidebarPosition, setSidebarPosition] = useState("left");
  const [compactMode, setCompactMode] = useState(false);

  /* Notifications state */
  const [notifications, setNotifications] = useState({
    email: true,
    push: true,
    sms: false,
    marketing: false,
  });

  /* Language state */
  const [language, setLanguage] = useState("English (US)");
  const [timezone, setTimezone] = useState("(GMT+05:30) Asia/Kolkata");
  const [dateFormat, setDateFormat] = useState("DD/MM/YYYY");

  /* Account state */
  const [twoFactor, setTwoFactor] = useState(false);

  /* Integrations state */
  const [integrations, setIntegrations] = useState({
    "google-calendar": true,
    slack: false,
    zoom: true,
    teams: false,
  });

  const renderTab = () => {
    switch (activeTab) {
      case "appearance":
        return (
          <SettingsAppearanceTab
            theme={theme}
            setTheme={setTheme}
            sidebarPosition={sidebarPosition}
            setSidebarPosition={setSidebarPosition}
            compactMode={compactMode}
            setCompactMode={setCompactMode}
          />
        );
      case "notifications":
        return (
          <SettingsNotificationsTab
            notifications={notifications}
            setNotifications={setNotifications}
          />
        );
      case "language":
        return (
          <SettingsLanguageTab
            language={language}
            setLanguage={setLanguage}
            timezone={timezone}
            setTimezone={setTimezone}
            dateFormat={dateFormat}
            setDateFormat={setDateFormat}
          />
        );
      case "account":
        return (
          <SettingsAccountTab
            twoFactor={twoFactor}
            setTwoFactor={setTwoFactor}
          />
        );
      case "integrations":
        return (
          <SettingsIntegrationsTab
            integrations={integrations}
            setIntegrations={setIntegrations}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="v2-settings-pg">
      {/* Header */}
      <div className="v2-settings-pg__header">
        <div className="v2-settings-pg__header-text">
          <h1 className="v2-settings-pg__title">Settings</h1>
          <p className="v2-settings-pg__subtitle">
            Manage your account preferences and configurations
          </p>
        </div>
        <button className="v2-settings-pg__save-btn">
          <SaveIcon size={16} color="#ffffff" />
          <span>Save All Changes</span>
        </button>
      </div>

      {/* Tabs */}
      <div className="v2-settings-pg__tabs">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              className={`v2-settings-pg__tab${isActive ? " v2-settings-pg__tab--active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={18} color={isActive ? "#eb1414" : "#6b7280"} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="v2-settings-pg__content">{renderTab()}</div>
    </div>
  );
};

export default SettingsPage;
